import {Component, OnInit} from '@angular/core';
import {NgxSmartModalService} from "ngx-smart-modal";
import {AuthService} from "../../../services/auth.service";

@Component({
    selector: 'lib-id-verification-settings',
    templateUrl: './id-verification-settings.component.html',
    styleUrls: ['./id-verification-settings.component.scss'],
    standalone: false
})
export class IdVerificationSettingsComponent implements OnInit {
  modalID: string;
  idVerified: boolean;
  mfaEnabled: boolean;
  modalContent: string;
  modalHeader: string;

  constructor(private ngxSmartModalService: NgxSmartModalService, private authService: AuthService) {}

  ngOnInit(): void {
    const currentUser = this.authService.currentUserAuthVO();
    this.idVerified = currentUser.idVerified;
    this.mfaEnabled = currentUser.totpEnabled;
    this.modalID = Math.random().toString(36).substring(7);
  }

  openIdConfirmation() {
    this.modalHeader='ID Verification';
    this.modalContent='By clicking "Proceed", you will be taken to a third party, Shufti Pro, to complete ID ' +
        'verification. For more information on this process, visit the ' +
        '<a href="https://www.iana.org/help/id-verification">ID Verification help page</a>.';
    this.ngxSmartModalService.open(this.modalID);
  }

  confirmIdVerification() {
    window.open('https://hvps.shuftipro.com/iana/', '_blank');
  }
}
